<div id="gleisMessDatenWrapper">
  <form clrForm>
    <clr-accordion clrAccordionMultiPanel="true">
      @for (mess_filter_check of mess_filter_Arr; track mess_filter_check; let i = $index) {
        <clr-accordion-panel
          [(clrAccordionPanelOpen)]="mess_filter_check.value"
          (clrAccordionPanelOpenChange)="openPart($event, i)"
          class="clr-row nxm margin-10-t">
          <clr-accordion-title class="w-100-p" style="display: flex; justify-content: space-between">
            <clr-checkbox-container style="pointer-events: none" class="margin-0-t padding-6-l">
              <clr-checkbox-wrapper>
                <label>{{ mess_keys[i] | tablePrettyPrint | mrTranslate }}</label>
                <input
                  type="checkbox"
                  [(ngModel)]="mess_filter_check.value"
                  [ngModelOptions]="{ standalone: true }"
                  clrCheckbox />
              </clr-checkbox-wrapper>
            </clr-checkbox-container>
          </clr-accordion-title>
          <clr-accordion-content *clrIfExpanded>
            @if (isEditable) {
              <clr-input-container>
                <label>{{ 'Minimum' | mrTranslate }}</label>
                <input clrInput="text" placeholder="1410" (blur)="changeMin($event)" />
              </clr-input-container>
            }
            @if (mess_filter_check.value) {
              <div class="margin-36-b margin-12-t">
                <ngx-slider
                  [class.invert-slider]="mess_comp[i].type == 'außer'"
                  [(value)]="lowValues[i]"
                  [(highValue)]="highValues[i]"
                  [options]="options[i]"></ngx-slider>
              </div>
            }
          </clr-accordion-content>
        </clr-accordion-panel>
      }
    </clr-accordion>
  </form>

  <br />

  <button type="button" class="btn btn-sm btn-primary" (click)="setFilters()">
    {{ 'Filter übernehmen' | mrTranslate }}
  </button>
  @if (_mess_filters.length) {
    <button style="min-width: 1.5rem" type="button" class="btn btn-danger btn-sm" (click)="deleteMessFilter()">
      <cds-icon shape="times" />
    </button>
  }

  @if (_mess_filters.length) {
    <div>
      @for (filt of _mess_filters; track filt) {
        @if (filt.key && filt.comp && filt.value != null) {
          <span class="label">
            {{
              filt.concat ?
                filt.concat == 'AND' ?
                  'UND '
                : 'ODER '
              : ''
            }}{{ filt.key }} {{ filt.comp }} {{ filt.value }}
          </span>
        }
      }
    </div>
  }

  <br />
  @if (showProgress) {
    <div class="progress loop" style="margin: auto; margin-top: 11px; max-width: 95%; height: 4px">
      <progress></progress>
    </div>
  }
  <br />
</div>
